import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cartSelectDisabled",
  "use": "icon-cartSelectDisabled-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cartSelectDisabled\">\n<circle cx=\"10\" cy=\"10\" r=\"9.25\" fill=\"#F2F2F2\" stroke=\"#E5E5E5\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol